<template>
  <div>
    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha">NOVIEMBRE.07.2025<br> – NEW BRAUNFELS, TEXAS</p>
      <h2 class="encabezado-nombres">
        <span class="nombre-principal">LUISA</span><br>
        <span class="apellidos-novios">Salinas Guajardo</span><br>
        <div class="separador-central">
          <img src="@/assets/and.png" alt="separador" class="imagen-separador" />
        </div>
        <span class="nombre-principal"> Arnulfo</span><br>
        <span class="apellidos-novios">Rodríguez Villafranca</span>
      </h2>
    </div>

    <div class="bienvenida-container">
      <p ref="textoPrincipalRef" class="bienvenida-text">{{ mensaje }}</p>
      <p ref="nosCasamosRef" class="textmia">{{ mensajeFinal }}</p>
    </div>

    <div class="bendicion-section" ref="bendicionRef">
      <div class="contenido-bendicion" ref="contenidoRef">
        <p class="linea" :ref="el => lineasRefs.push(el)">Con la bendición de Dios</p>
        <p class="linea" :ref="el => lineasRefs.push(el)">y de nuestros padres:</p>
        <br><br>

        <div class="padres-bloque">
          <p class="linea" :ref="el => lineasRefs.push(el)">María de Jesús Morales Cuevas</p>
        </div>
        <br><br>

        <div class="padres-bloque">
          <p class="linea" :ref="el => lineasRefs.push(el)">José Magaña Maldonado</p>
          <p class="linea" :ref="el => lineasRefs.push(el)">Martha Guadalupe Guzmán Zaragoza <span class="cruz">†</span></p>
        </div>
        <br><br>

        <p class="linea" :ref="el => lineasRefs.push(el)">Queremos invitarlos a celebrar nuestra boda.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'SeccionBendicionPadres',
  setup() {
    const bendicionRef = ref(null);
    const contenidoRef = ref(null);
    const lineasRefs = ref([]);
    const encabezadoRef = ref(null);
    const textoPrincipalRef = ref(null);
    const nosCasamosRef = ref(null);

    const mensaje = ref('');
    const mensajeFinal = ref('');

    const text = 'Cuando el amor es verdadero, el interes se nota; la distancia y los miedos no importan y arriesgar nunca es un problema. \n\n Por que lo importante: no son las circunstancias, son las ganas, no es cada quien por su lado, sino JUNTOS EN TODO, con la persona indicada siempre tendras ganas de todo.'
    const textFinal = '¡Nos Casamos!'

    onMounted(() => {
      nextTick(() => {
        lineasRefs.value = [];

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              gsap.set(lineasRefs.value, { opacity: 0, y: 40 });

              gsap.to(lineasRefs.value, {
                opacity: 1,
                y: 0,
                stagger: 0.4,
                duration: 1.2,
                ease: 'power2.out'
              });
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.3 });

        if (bendicionRef.value) observer.observe(bendicionRef.value);
      });

      // Animaciones para encabezado y bienvenida
      gsap.set([
        encabezadoRef.value,
        textoPrincipalRef.value,
        nosCasamosRef.value,
      ], { opacity: 0, y: 40 });

      const observer2 = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });
            mensaje.value = text;
            mensajeFinal.value = textFinal;

            tl.to(encabezadoRef.value, { y: 0, opacity: 1 })
              .to(textoPrincipalRef.value, { y: 0, opacity: 1 }, "-=0.5")
              .to(nosCasamosRef.value, { y: 0, opacity: 1 }, "-=0.4");

            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      if (encabezadoRef.value) observer2.observe(encabezadoRef.value);
    });

    return {
      bendicionRef,
      contenidoRef,
      lineasRefs,
      encabezadoRef,
      textoPrincipalRef,
      nosCasamosRef,
      mensaje,
      mensajeFinal
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap');

.bendicion-section {
  background-color: rgb(130, 124, 99);
  padding: 60px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.contenido-bendicion {
  font-family: 'Playfair Display', serif;
  color: #fff;
  font-size: 16px;
  line-height: 0.5;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.padres-bloque {
  margin: 8px 0;
}

.linea {
  opacity: 0;
}

.cruz {
  font-size: 14px;
  margin-left: 4px;
  display: inline-block;
}

.encabezado-container {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
    color: #555;

  opacity: 0;
  transform: translateY(50px);
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.apellidos-novios {
  font-size: 30px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  color: #cfcfcf;
}

.bienvenida-container {
  text-align: center;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
  white-space: pre-line;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #302f2d;
  margin-top: 20px;
  opacity: 0;
}

.separador-central {
  text-align: center;
  margin: 10px 0;
}

.imagen-separador {
  width: 150px;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  filter: brightness(0.4) contrast(1.2);
  opacity: 0.8;
}
</style>